/* socialDavky — ORIENTAČNÍ odhad státních dávek z čistého měsíčního příjmu + věku.
 *
 * NENÍ to přesný výpočet ČSSZ — je to rychlý odhad „v duchu beplan" (jednoduchý,
 * srozumitelný, pro schůzku s klientem), aby poradce ukázal: kolik klient reálně
 * dostane od státu a KOLIK MU CHYBÍ (výpadek příjmu). Stejná filozofie jako náš
 * pojišťovací engine (lib/pojisteniEngine).
 *
 * Výstup je vždy označený jako orientační. Konstanty dole jdou kdykoliv doladit
 * (mění se každý rok), aniž by se sahalo do logiky.
 *
 * Ověřeno proti reálnému výstupu konkurence (čistý 53 950 → starobní ~28k, inval.
 * III ~28k, II ~16k, I ~12k) — sedí řádově. Čistá 53 950 je čistá z hrubé přesně
 * 70 000 (daně 2026); od převodu čistá → hrubá po pásmech (5. 10. 2026, velká
 * kontrola M2-02) dává invalidní III. stupně 28 233, dřív s × 1,39 29 125.
 */

/* ⚠️ ŠABLONOVÉ KONSTANTY — poradce si je ověří.
 * Nejsou garance ani citace zákona; jsou to orientační vzory pro schůzku.
 * Mění se KAŽDÝ LEDEN — proto nesou `PLATNE_OD` a jsou pohromadě.
 * `ZEME: "CZ"` — celý soubor počítá české dávky. Na SK (jiný systém: vdovský
 * 60 % starobného, nemocenské 55 % DVZ od 11. dne) se NEPOUŽÍVÁ; kalkulačka
 * tabulku na EUR skrývá. SK větev zatím NENÍ hotová — viz docs/POJISTNA-METODIKA.md. */
export const DAVKY_META = {
  ZEME: "CZ",
  PLATNE_OD: "2026-01-01",
  SABLONA: true,
  klicPoznamka: "davkyUi.poznamka",
  poznamka:
    "Orientační odhad podle pravidel platných od 1. 1. 2026. Hodnoty se každý leden mění — poradce ověří aktuální čísla ČSSZ. Není garance ani nabídka.",
  poznamkaSk:
    "Orientačný odhad podľa pravidiel platných od 1. 1. 2026. Hodnoty sa každý január menia — poradca overí aktuálne čísla. Nie je garancia ani ponuka.",
  /* Odkud jsou čísla. Bez zdroje se konstanta nemění — příště se musí poznat,
   * jestli je hodnota vyhlášená, nebo ji někdo odhadl. */
  zdroje: [
    {
      co: "Přehled nejdůležitějších údajů pro sociální zabezpečení v roce 2026 (základní výměra 4 900 Kč, redukční hranice důchodu 21 546 / 195 868 Kč se zápočtem 99 % a 26 %, procentní výměra 1,495 % za rok pojištění, redukční hranice nemocenského 1 633 / 2 449 / 4 897 Kč, sazby 60 / 66 / 72 %)",
      url: "https://www.cssz.gov.cz/-/prehled-nejdulezitejsich-udaju-pro-socialni-zabezpeceni-v-roce-2026",
      overeno: "2026-08-23",
    },
    /* OPRAVENO 4. 10. 2026: citace „0,5 % / 0,75 %“ neodpovídala textu zákona.
     * § 41 odst. 2 říká, že procentní výměra II. a I. stupně je POLOVINA
     * a TŘETINA výměry III. stupně (v roce 2026 tedy 0,7475 % a 0,4983 %). */
    {
      co: "Invalidní důchod — procentní výměra II. stupně = polovina, I. stupně = třetina výměry III. stupně; minimum procentní výměry = základní výměra / její polovina / třetina (9 800 / 7 350 / 6 534 Kč celkem); nárok § 40 (nad 28 let 5 let pojištění z posledních 10); dopočtená doba do důchodového věku podle data narození a její krácení",
      predpis: "155/1995 Sb., § 32 odst. 3, § 40, § 41 odst. 2, 3, 5 a 6, § 42 odst. 2–4, příloha 1 (znění 1. 1.–31. 12. 2026)",
      url: "https://www.cssz.gov.cz/invalidni-duchody-podrobne",
      overeno: "2026-10-04",
    },
    /* Převod čistá → hrubá (velká kontrola 4.–5. 10. 2026, M2-02): parametry
     * zaměstnance 2026 bez slevy na dítě. Do té doby plochý koeficient 1,39
     * ze superhrubé mzdy před rokem 2021, který hrubou mzdu nadsazoval v celém
     * rozsahu (čistá 30 000 → nemocenská 22 210 místo 19 904). */
    {
      co: "Čistá mzda zaměstnance 2026: sociální pojištění 7,1 % (do maximálního vyměřovacího základu 48× průměrné mzdy = 195 868 Kč/měs), zdravotní 4,5 % (bez stropu), daň 15 % a 23 % nad 36× průměrné mzdy (146 901 Kč/měs), sleva na poplatníka 30 840 Kč/rok (2 570 Kč/měs); průměrná mzda 48 967 Kč — kontrola: hrubá 40 000 → čistá 31 930",
      predpis: "586/1992 Sb. § 16 a § 35ba; 589/1992 Sb. § 7 a § 15a; 592/1992 Sb. § 2 (znění 2026)",
      prevzato: "velká kontrola 4.–5. 10. 2026, nález M2-02 (M2/m2_davky.mjs)",
      overeno: "2026-10-05",
    },
    {
      co: "Minimální vyměřovací základ OSVČ 2026 (17 139 Kč po novele, 35 % průměrné mzdy) — podklad odhadu důchodu OSVČ na minimálních zálohách",
      url: "https://www.cssz.gov.cz/zmena-vyse-minimalnich-zaloh-osvc-v-roce-2024",
      overeno: "2026-10-04",
    },
  ],
};

// — Laditelné konstanty (ŠABLONA, viz DAVKY_META.PLATNE_OD) ——————————————
const ZAKLADNI_VYMERA = 4900;      // základní výměra důchodu 2026 (Kč/měs, pevná složka) — ČSSZ
const RH1 = 21546;                 // 1. redukční hranice důchodu 2026 (Kč/měs) — ČSSZ
const RH2 = 195868;                // 2. redukční hranice důchodu 2026 (Kč/měs) — ČSSZ
/* ⚠️ DŮCHODOVÁ REFORMA: do 1. redukční hranice se od roku 2026 NEZAPOČÍTÁVÁ 100 %,
 * ale 99 % — a u důchodů přiznaných v dalších letech to klesá o 1 p. b. ročně až
 * na 90 % v roce 2035 (viz REFORMA_SNIZOVANI). Do roku 2025 tu bylo natvrdo 100 %. */
const RH1_KOEF = 0.99;             // zápočet do 1. redukční hranice pro důchod přiznaný v roce 2026
const RED_KOEF = 0.26;             // redukce mezi hranicemi
/* Orientační důchodový věk. EXPORTOVANÝ, protože ho potřebuje i cíl „do důchodu"
 * (lib/duchodCil.js) na horizont spoření. Dřív by si ho musel opsat = druhý zdroj
 * pravdy a tichý drift, až se věk odchodu do penze zase posune. ŠABLONA jako zbytek
 * souboru (viz DAVKY_META) — po novele se váže na naději dožití, poradce ověří. */
export const DUCHODOVY_VEK = 65;
const START_PRACE = 20;            // orientační začátek pojištění (let)
const COEF_ROK = 0.01495;          // procentní výměra 2026: 1,495 % výpočtového základu / rok (starobní + invalidita III. st.); klesá na 1,45 % do 2035
/* ⚠️ PŮVODNÍ KOEFICIENTY (do metodiky plánu 5. 10. 2026). Zákon říká polovinu
 * a třetinu III. stupně (§ 41 odst. 2), ne 0,75 % a 0,5 %. Zůstávají JEN pro
 * výpočet postaru (`invaliditaPostaru`) — uložené plány se nepřepočítávají. */
const COEF_INVAL_II = 0.0075;      // postaru: invalidita II. stupně 0,75 % / rok
const COEF_INVAL_I = 0.005;        // postaru: invalidita I. stupně 0,5 % / rok
/* ⚠️ PŮVODNÍ PŘEVOD ČISTÁ → HRUBÁ (do metodiky plánu 5. 10. 2026). Poměr ze
 * superhrubé mzdy před rokem 2021 — s daněmi 2026 nadsazuje hrubou mzdu
 * v celém rozsahu (velká kontrola M2-02). Zůstává JEN pro výpočet postaru
 * (`invaliditaPostaru` z lib/planEngine.js / `{ postaru: true }`) — uložené
 * plány se nepřepočítávají. Jinak `hrubaZCisteCZ` po pásmech. */
const NET_TO_GROSS = 1.39;         // postaru: hrubý ≈ čistý × 1,39

/* ── ČISTÁ → HRUBÁ PO PÁSMECH (zaměstnanec 2026, bez slevy na dítě) ─────────
 * Velká kontrola 4.–5. 10. 2026 (M2-02), zdroje v DAVKY_META. Čistá mzda je
 * po částech lineární funkce hrubé — zlomy:
 *   1) sleva na poplatníka vynuluje daň (hrubá 17 133, čistá = 0,884 · H),
 *   2) daň 23 % nad 36× průměrné mzdy (hrubá 146 901, sklon 0,654),
 *   3) strop sociálního pojištění 48× průměrné mzdy (hrubá 195 868, sklon 0,725).
 * Mezi 1) a 2) čistá = 0,734 · H + 2 570. Inverze jde po týchž úsecích, takže
 * hrubaZCisteCZ(cistaZHrubeCZ(H)) = H. Samotný vzorec (c − 2 570) / 0,734 by
 * u nízkých mezd lhal (čistá 12 000 → 12 847 místo 13 575). */
export const MZDA_CZ_2026 = Object.freeze({
  SP: 0.071,                 // sociální pojištění zaměstnance
  ZP: 0.045,                 // zdravotní pojištění zaměstnance
  DAN: 0.15,
  DAN_VYSSI: 0.23,
  SLEVA_MES: 2570,           // sleva na poplatníka 30 840 / 12
  PRUMERNA_MZDA: 48967,      // VVZ 2024 × 1,0581 (ČSSZ Přehled 2026), totéž co INVALIDITA_CZ_2026
  DAN_VYSSI_NASOBEK: 3,      // 36násobek ročně = 3× měsíčně
  STROP_SP_NASOBEK: 4,       // maximální vyměřovací základ 48× ročně = 4× měsíčně
});

/** Čistá měsíční mzda zaměstnance z hrubé (2026, bez slevy na dítě). */
export function cistaZHrubeCZ(hruba) {
  const M = MZDA_CZ_2026;
  const H = fin0(hruba);
  const hDan2 = M.DAN_VYSSI_NASOBEK * M.PRUMERNA_MZDA;
  const stropSP = M.STROP_SP_NASOBEK * M.PRUMERNA_MZDA;
  const sp = M.SP * Math.min(H, stropSP);
  const zp = M.ZP * H;
  const dan = Math.max(0, M.DAN * Math.min(H, hDan2) + M.DAN_VYSSI * Math.max(0, H - hDan2) - M.SLEVA_MES);
  return H - sp - zp - dan;
}

/**
 * Hrubá měsíční mzda z čisté (inverze `cistaZHrubeCZ` po úsecích).
 * @param {number} cista čistý měsíční příjem
 * @param {{postaru?: boolean}} [o] `postaru` = čistá × 1,39 (uložené plány)
 */
export function hrubaZCisteCZ(cista, o = {}) {
  const c = fin0(cista);
  if (o && o.postaru) return c * NET_TO_GROSS;
  if (!(c > 0)) return 0;
  const M = MZDA_CZ_2026;
  const zlomy = [0, M.SLEVA_MES / M.DAN, M.DAN_VYSSI_NASOBEK * M.PRUMERNA_MZDA, M.STROP_SP_NASOBEK * M.PRUMERNA_MZDA];
  for (let i = 1; i < zlomy.length; i += 1) {
    const h0 = zlomy[i - 1];
    const h1 = zlomy[i];
    const c1 = cistaZHrubeCZ(h1);
    if (c <= c1) {
      const c0 = cistaZHrubeCZ(h0);
      return h0 + ((c - c0) * (h1 - h0)) / (c1 - c0);
    }
  }
  /* Nad stropem sociálního pojištění: sklon 1 − ZP − DAN_VYSSI. */
  const hS = zlomy[zlomy.length - 1];
  return hS + (c - cistaZHrubeCZ(hS)) / (1 - M.ZP - M.DAN_VYSSI);
}

/* ── DŮCHODOVÁ REFORMA: parametry podle ROKU PŘIZNÁNÍ důchodu ────────────────
 * Zápočet do 1. redukční hranice klesá ze 100 % (2025) o 1 p. b. ročně na 90 %
 * (2035) a procentní výměra z 1,5 % o 0,005 p. b. ročně na 1,45 % (2035).
 * Týká se jen důchodů PŘIZNANÝCH po roce 2025 — už přiznané se nepřepočítávají.
 * Zdroj: ČSSZ, Důchodová reforma, ověřeno 2026-08-23.
 *
 * PROČ TO TU JE: klientovi, kterému je dnes 40, se starobní důchod nepřizná podle
 * parametrů roku 2026, ale podle roku, kdy dosáhne důchodového věku. Počítat mu ho
 * dnešními čísly znamená NADHODNOTIT státní důchod — a tím podhodnotit, kolik si
 * musí odložit sám. Invalidita se naopak přiznává teď, ta bere aktuální rok.
 *
 * ⚠️ Mimo rozsah se NEEXTRAPOLUJE nad rámec zákona: před 2026 platí 100 % / 1,5 %,
 * od 2035 dál 90 % / 1,45 % (zákonná cílová hodnota, ne dopočet trendu). */
export const REFORMA_SNIZOVANI = {
  odRoku: 2026,
  doRoku: 2035,
  zapocetRH1: { start: 1.0, krokRocne: 0.01, cil: 0.90 },
  koefRok: { start: 0.015, krokRocne: 0.00005, cil: 0.0145 },
};

/** Parametry výpočtu důchodu pro daný rok přiznání (viz REFORMA_SNIZOVANI). */
export function parametryProRokPriznani(rok) {
  const r = Math.trunc(+rok);
  if (!Number.isFinite(r) || r < REFORMA_SNIZOVANI.odRoku) {
    return { rok: r, zapocetRH1: REFORMA_SNIZOVANI.zapocetRH1.start, koefRok: REFORMA_SNIZOVANI.koefRok.start };
  }
  const kroku = Math.min(r, REFORMA_SNIZOVANI.doRoku) - (REFORMA_SNIZOVANI.odRoku - 1);
  return {
    rok: r,
    zapocetRH1: +(REFORMA_SNIZOVANI.zapocetRH1.start - kroku * REFORMA_SNIZOVANI.zapocetRH1.krokRocne).toFixed(4),
    koefRok: +(REFORMA_SNIZOVANI.koefRok.start - kroku * REFORMA_SNIZOVANI.koefRok.krokRocne).toFixed(6),
  };
}

/* NEMOCENSKÁ — redukovaný DENNÍ vyměřovací základ z HRUBÉHO příjmu.
 * PROČ ne „60 % z čistého": zákon počítá procento z REDUKOVANÉHO denního
 * vyměřovacího základu z hrubého, a plnění se nedaní. Plochých 60 % z čistého
 * je jiná veličina a mýlí se OBĚMA směry: u průměrných příjmů dávku podceňuje
 * (→ nafoukne potřebu PN), u vysokých ji přeceňuje (→ podpojistí PN), protože
 * ignoruje redukční hranice. Ty jsou u nemocenské jiné než u důchodu. */
const NEM_RH1 = 1633;              // 2026: do 1. RH se započítá 90 % DVZ (Kč/den) — ČSSZ
const NEM_RH2 = 2449;              // 2026: mezi 1.–2. RH 60 %
const NEM_RH3 = 4897;              // 2026: mezi 2.–3. RH 30 %; nad 3. RH se nezapočítává nic
const NEM_K1 = 0.90, NEM_K2 = 0.60, NEM_K3 = 0.30;
const NEM_SAZBA_DO_30 = 0.60;      // 60 % RDVZ do 30. dne (od 31. 66 %, od 61. 72 %)
export const NEMOCENSKA_OD_DNE = 15; // prvních 14 dní platí náhradu mzdy zaměstnavatel
// ————————————————————————————————————————————————————————————————

const fin0 = (x) => { const n = +x; return Number.isFinite(n) ? Math.max(0, n) : 0; };

// Výpočtový základ z hrubého měsíčního příjmu (redukční hranice DŮCHODU).
function vypoctovyZaklad(hrubyMes, zapocet = RH1_KOEF) {
  if (hrubyMes <= RH1) return zapocet * hrubyMes;
  const zaklad = zapocet * RH1;
  if (hrubyMes <= RH2) return zaklad + RED_KOEF * (hrubyMes - RH1);
  return zaklad + RED_KOEF * (RH2 - RH1);
}

/* Redukovaný denní vyměřovací základ pro NEMOCENSKOU (z hrubého měsíčního příjmu). */
export function redukovanyDVZ(hrubyMes) {
  const dvz = fin0(hrubyMes) * 12 / 365;
  const p1 = Math.min(dvz, NEM_RH1) * NEM_K1;
  const p2 = Math.max(0, Math.min(dvz, NEM_RH2) - NEM_RH1) * NEM_K2;
  const p3 = Math.max(0, Math.min(dvz, NEM_RH3) - NEM_RH2) * NEM_K3;
  return p1 + p2 + p3;
}

/**
 * nemocenskaMes — JEDINÝ zdroj pravdy pro státní nemocenskou (Kč/měs).
 * Používá ji i pojisteniEngine, aby konstanty nedriftovaly ve dvou souborech.
 * @param {number} cistyPrijem čistý měsíční příjem
 * @param {boolean} osvc OSVČ bez nemocenského pojištění → 0
 */
export function nemocenskaMes(cistyPrijem, osvc = false, o = {}) {
  if (osvc) return 0;
  const cisty = fin0(cistyPrijem);
  if (cisty <= 0) return 0;
  /* Hrubá z čisté po pásmech (M2-02, 5. 10. 2026); `o.postaru` = × 1,39. */
  const den = redukovanyDVZ(hrubaZCisteCZ(cisty, o)) * NEM_SAZBA_DO_30;
  // Dávka se nedaní → nikdy nesmí vyjít víc, než kolik člověk čistého vydělá.
  return Math.min(cisty, Math.round(den * 30));
}

/**
 * nemocenskaDetail — mezikroky nemocenské pro rozklik „Jak se počítá pracovní
 * neschopnost“ v kartě plánu (5. 10. 2026, majitel: „pracovní neschopnost
 * není taky vysvětlení, jak se to počítá“). ŽÁDNÝ VLASTNÍ VÝSLEDEK: `mes` je
 * přímo `nemocenskaMes(…)`, mezikroky (hrubá, denní základ, redukce) jdou
 * TĚMIŽ funkcemi (`hrubaZCisteCZ`, `redukovanyDVZ`). Obrazovka mezikroky
 * ukáže jen tehdy, když z nich `mes` opravdu vyjde (`sedi`) — kdyby se výpočet
 * jednou rozešel, zůstane vidět jen číslo, ne nesouhlasný rozpad.
 * @param {number} cistyPrijem čistý měsíční příjem
 * @param {boolean} [osvc] OSVČ bez nemocenského pojištění → 0
 * @param {object} [o] totéž `o` jako `nemocenskaMes` (`postaru`)
 */
export function nemocenskaDetail(cistyPrijem, osvc = false, o = {}) {
  const cisty = fin0(cistyPrijem);
  const mes = nemocenskaMes(cistyPrijem, osvc, o);
  /* Strop dávky: z denního základu nad 3. redukční hranicí se nezapočte nic. */
  const stropMes = Math.round(redukovanyDVZ(NEM_RH3 * 365 / 12) * NEM_SAZBA_DO_30 * 30);
  const zaklad = {
    zeme: "CZ", osvc: !!osvc, pojisten: !osvc, cisty, hruby: 0, dvz: 0, rdvz: 0,
    sazba: NEM_SAZBA_DO_30, den: 0, mes, uStropu: false, stropMes, stropDvz: NEM_RH3,
    odDne: NEMOCENSKA_OD_DNE, omezenoCistym: false, sedi: mes === 0,
  };
  if (osvc || cisty <= 0) return zaklad;
  const hruby = hrubaZCisteCZ(cisty, o);
  const dvz = hruby * 12 / 365;
  const rdvz = redukovanyDVZ(hruby);
  const den = rdvz * NEM_SAZBA_DO_30;
  const zDavky = Math.round(den * 30);
  return {
    ...zaklad, hruby, dvz, rdvz, den, uStropu: dvz > NEM_RH3,
    omezenoCistym: zDavky > cisty, sedi: Math.min(cisty, zDavky) === mes,
  };
}

// vek z data narození (YYYY-MM-DD nebo Date) — pokud není, vrátí fallback.
export function vekZData(narozeni, fallback = 35) {
  if (!narozeni) return fallback;
  const d = new Date(narozeni);
  if (isNaN(d.getTime())) return fallback;
  const v = Math.floor((Date.now() - d.getTime()) / 31557600000);
  return v > 0 && v < 110 ? v : fallback;
}

/* ═══ INVALIDNÍ DŮCHOD PODLE ZÁKONA (balík 4. 10. 2026, body 1–4 „ANO“) ══════
 * Majitel 4. 10. 2026 („ok vse dle doporučení“) schválil opravu odhadu
 * invalidního důchodu podle zákona 155/1995 Sb. (náhled čísel před a po:
 * beplan-pracovni/2026-10-04-priprava/duchod-pred-po.md, tabulky A a B):
 *
 *  1. Dopočtená doba do DŮCHODOVÉHO VĚKU PODLE ROKU NAROZENÍ (§ 41 odst. 5,
 *     § 32 odst. 3, příloha 1), ne do pevných 65 let — a jen do věku osoby,
 *     ne „vždy 45 let“.
 *  2. Krácení dopočtené doby, když od 18 let do invalidity není kryto českým
 *     pojištěním (§ 41 odst. 6) — pole „V Česku pojištěn/a od roku“.
 *     Roky před příchodem ŘEDÍ průměr výdělku (§ 16 odst. 1, § 18 odst. 1;
 *     bod 2 „ANO“). ⚠️ 4. 10. 2026 ~22:50 majitel pole zrušil („Úplně
 *     odstranit“): `spocitejDavky` rok nepředává, počítá se celý život v ČR;
 *     krácení a ředění zůstávají jen v `invalidniDuchodCZ` (parametr).
 *  3. Minima: procentní výměra III / II / I nejméně 4 900 / 2 450 / 1 634 Kč
 *     (§ 41 odst. 3 → 9 800 / 7 350 / 6 534 Kč celkem) a při 15+ letech
 *     doby pojištění 45 % výpočtového základu z průměrné mzdy (§ 42 odst. 4;
 *     pod 28 let s krytím od 18 § 42 odst. 3).
 *  4. II. a I. stupeň = polovina a třetina III. stupně (§ 41 odst. 2).
 *  5. Nárok (§ 40): pod potřebnou dobou pojištění (nad 28 let 5 z 10) = 0.
 *  6. OSVČ se počítá VŽDY z minimálních záloh (bod 3 „ANO“): základ = průměr
 *     minimálních vyměřovacích základů, ne čistý × 1,39. Volbu „OSVČ platí
 *     jen minimální zálohy“ majitel 5. 10. 2026 zrušil („dej pryč“) — uložená
 *     odpověď „ne“ se ignoruje.
 *
 * NEMĚNÍ SE: starobní důchod (bod 5 „NE“ — důchodový věk podle ročníku jen
 * u invalidity), `DUCHODOVY_VEK = 65` (horizont spoření), nemocenská.
 * Uložené plány před metodikou 5. 10. 2026 počítají postaru
 * (`invaliditaPostaru: true` z lib/planEngine.js) — pravidlo 3. 10. 2026. */
export const INVALIDITA_CZ_2026 = {
  PLATNE_OD: "2026-01-01",
  /* § 41 odst. 3 — minimum PROCENTNÍ výměry (k ní se přičte základní 4 900). */
  MIN_PROCENTNI: { III: 4900, II: 2450, I: 1634 },
  /* VVZ 2024 46 278 × přepočítací koeficient 1,0581 (ČSSZ Přehled 2026) —
   * základ pro minimum 45 % (§ 42). */
  PRUMERNA_MZDA: 48967,
  MIN45_PODIL: 0.45,
  MIN45_LET: 15,
  /* OSVČ na minimálních zálohách — průměr PŘEPOČTENÝCH minimálních
   * vyměřovacích základů (25 % průměrné mzdy do 2023, 30 % 2024, 35 % 2025)
   * ≈ 12 819 Kč. ⚠️ ODHAD (nedoloženo, viz duchod-pred-po.md „Nedoloženo“);
   * u OSVČ na minimu výsledek stejně padá na zákonné minimum. */
  OSVC_MIN_OVZ: 12819,
  /* Minimální měsíční vyměřovací základ OSVČ 2026 po novele (ČSSZ) — jen
   * informace, do průměru kariéry se nedosazuje. */
  OSVC_MIN_VZ_2026: 17139,
};

/** Důchodový věk pro DOPOČTENOU DOBU (§ 41 odst. 5: věk ženy bez dětí téhož
 *  data narození = u ročníků 1965+ stejný jako u mužů). V letech (desetinně).
 *  Neplatný rok → `DUCHODOVY_VEK` (65, dosavadní předpoklad). */
export function duchodovyVekCZ(rokNarozeni) {
  const r = Math.trunc(+rokNarozeni);
  if (!Number.isFinite(r) || r < 1900) return DUCHODOVY_VEK;
  if (r >= 1989) return 67;                                   // § 32 odst. 3 věta druhá
  if (r >= 1974) return 65 + (8 + (r - 1973)) / 12;           // § 32 odst. 3 věta první
  if (r >= 1965) return 65 + (r - 1965) / 12;                 // příloha 1 (ženy bez dětí)
  return 65;                                                  // starší ročníky: orientačně
}

/** § 40 odst. 1 — potřebná doba pojištění podle věku (let). */
export function potrebnaDobaLet(vek) {
  if (vek < 20) return 0.01;
  if (vek < 22) return 1;
  if (vek < 24) return 2;
  if (vek < 26) return 3;
  if (vek < 28) return 4;
  return 5;
}

/** § 41 odst. 6 písm. a) — tolerance nekryté doby (let). */
const toleranceLet = (vek) => (vek < 28 ? 1 : vek < 40 ? 2 : 3);

/** Rok (1900–2200) z čísla / textu; jinak `null`. „“ / null / 0 = nezadáno. */
export function rokNeboNull(x) {
  if (x === null || x === undefined || x === "" || typeof x === "boolean") return null;
  const n = Math.trunc(+String(x).trim());
  return Number.isFinite(n) && n >= 1900 && n <= 2200 ? n : null;
}

/** „ano“ / „ne“ / „nevim“ / null — tolerantní (true/false, „nevím“). */
export function normNarok(x) {
  if (x === true || x === "ano") return "ano";
  if (x === false || x === "ne") return "ne";
  if (x === "nevim" || x === "nevím") return "nevim";
  return null;
}

/**
 * invalidniDuchodCZ — výše invalidního důchodu (Kč/měs) podle zákona, ORIENTAČNĚ
 * (ne výpočet ČSSZ; jistotu dá Informativní osobní list důchodového pojištění).
 *
 * @param {object} p
 *   ovz            osobní vyměřovací základ (Kč/měs; zaměstnanec = hrubý z čistého)
 *   vek            věk v roce přiznání (let); `null` = neznámý
 *   rokNarozeni    rok narození; `null` = neznámý
 *   rokDnes        rok přiznání
 *   pojistenOdRoku rok, od kterého je v ČR pojištěný; `null` = celý život v ČR
 *                  (dosavadní předpoklad: pracuje od 20 let, kryto od 18).
 *                  ⚠️ APLIKACE HO OD 4. 10. 2026 NEPŘEDÁVÁ: pole „V Česku
 *                  pojištěn/a od roku“ majitel zrušil („Úplně odstranit“),
 *                  `spocitejDavky` počítá vždy celý život v ČR. Parametr
 *                  zůstává jen jako úplný zákonný výpočet (§ 41 odst. 6, § 16).
 *   narok          „ano“ = poradce ví, že nárok má (doba pojištění se nekontroluje),
 *                  „ne“ = bez nároku, jinak se nárok zkontroluje z doby pojištění (§ 40)
 *   vyloucenoLet   vyloučené roky v rozhodném období (péče o dítě) — jen pro ředění
 *   redeni         ředění průměru roky před příchodem (§ 16, § 18) — výchozí ano
 *
 * BEZ DATA NAROZENÍ A VĚKU se počítá jako dřív: dopočtená doba do 65 let,
 * věk 35 (`chybiNarozeni: true` → obrazovka řekne „doplňte datum narození“).
 */
export function invalidniDuchodCZ({ ovz = 0, vek = null, rokNarozeni = null, rokDnes = 2026, pojistenOdRoku = null, narok = null, vyloucenoLet = 0, redeni = true } = {}) {
  const P = INVALIDITA_CZ_2026;
  const rokD = rokNeboNull(rokDnes) ?? 2026;
  const vekZadany = vek !== null && vek !== undefined && vek !== "" && Number.isFinite(+vek) && +vek >= 0 && +vek < 120;
  const rokZadany = rokNeboNull(rokNarozeni);
  const chybiNarozeni = rokZadany == null && !vekZadany;
  const vekEf = vekZadany ? +vek : (rokZadany != null ? Math.max(0, rokD - rokZadany) : 35);
  const rokNar = rokZadany != null ? rokZadany : rokD - Math.round(vekEf);
  /* Bez data narození dopočtená doba do 65 (jako dřív), ne do věku ročníku. */
  const dv = chybiNarozeni ? DUCHODOVY_VEK : duchodovyVekCZ(rokNar);
  /* ROK PŘÍCHODU — HRANICE (dočištění 4. 10. 2026, ověření dráhy P).
   * Od 4. 10. 2026 ~22:50 ho aplikace nepředává (pole zrušeno), blok platí
   * jen pro přímé volání této funkce:
   *  · rok v BUDOUCNOSTI je překlep (2030 místo 2003) — dřív dal „bez nároku“,
   *    důchod 0 a krytí skočilo nahoru. Počítá se jako nezadaný (celý život
   *    v ČR); detail nese `rokPrichoduVBudoucnu` (štítek už žádná obrazovka nemá),
   *  · příchod PŘED 20. rokem: doba pojištění se počítá od 20 let (START_PRACE)
   *    jako u prázdného pole, nekrytá doba jen od 18 let do příchodu. Dřív se
   *    doba počítala od příchodu (nejdřív od 18), takže rok před 18.
   *    narozeninami dal VYŠŠÍ důchod než prázdné pole — týž člověk dvě čísla
   *    (a u 33–34 let se tím přepínalo i minimum 45 %). Příchod do 18 let =
   *    na korunu prázdné pole; příchod po 20 letech beze změny.
   * `pojistenOdRoku` v detailu zůstává ZADANÝ rok (obrazovky podle něj
   * poznají, že pole vyplněné je); výpočet bere `prichod`. */
  const prichodZadany = rokNeboNull(pojistenOdRoku);
  const rokPrichoduVBudoucnu = prichodZadany != null && prichodZadany > rokD;
  const prichod = rokPrichoduVBudoucnu ? null : prichodZadany;
  const znamPrichod = prichod != null;
  const vekPrichodu = znamPrichod ? prichod - rokNar : null;
  const vekOd = znamPrichod ? Math.max(START_PRACE, vekPrichodu) : START_PRACE;
  const dobaDosud = Math.max(0, vekEf - vekOd);                       // skutečná doba pojištění (let)
  const nekryto = znamPrichod ? Math.max(0, vekPrichodu - 18) : 0;
  const zaklad = {
    narokSplnen: true, duvod: null, dv: +dv.toFixed(4), vek: vekEf, rokNarozeni: rokNar, chybiNarozeni,
    pojistenOdRoku: prichodZadany, dobaDosud: +dobaDosud.toFixed(2), potrebnaDoba: potrebnaDobaLet(vekEf),
    ...(rokPrichoduVBudoucnu ? { rokPrichoduVBudoucnu: true } : null),
  };
  const nulovy = (duvod) => ({
    ...zaklad, III: 0, II: 0, I: 0, narokSplnen: false, duvod,
    dopoctena: 0, kraceni: 0, kraceno: false, roky: 0, ovz: 0, vz: 0, minimum: null, redeni: false,
  });
  const n = normNarok(narok);
  if (n === "ne") return nulovy("ne");
  /* MLADÝ S PŘÍJMEM (velká kontrola M2-06, 5. 10. 2026): § 40 odst. 1 písm. a)
   * žádá do 20 let méně než rok pojištění a § 40 odst. 3 pro nárok započítá
   * i studium na SŠ / VŠ. S orientačním začátkem pojištění ve 20 letech
   * (START_PRACE) vycházela výdělečná osoba 18–21 let „bez nároku“ (důchod 0),
   * ve 21 letech najednou 22 301 Kč. Nárok se u ní bere jako splněný — mění se
   * JEN test nároku, ne doba pro výši důchodu (posun START_PRACE by hnul čísla
   * všem klientům). */
  const mladySPrijmem = vekEf < 22 && fin0(ovz) > 0;
  if (n !== "ano" && !mladySPrijmem && dobaDosud < potrebnaDobaLet(vekEf)) return nulovy("doba");

  // § 41 odst. 6 — krácení dopočtené doby (bez pole = kryto od 18, jako dřív)
  const kraceni = nekryto < toleranceLet(vekEf) ? 1 : Math.max(0, vekEf - 18 - nekryto) / Math.max(1, vekEf - 18);
  const dopoctena = Math.max(0, dv - vekEf) * kraceni;
  const roky = Math.floor(dobaDosud + dopoctena + 1e-9);              // § 41 odst. 2: za každý celý rok

  // Ředění průměru: rozhodné období od roku po 18. narozeninách do roku před přiznáním
  let ovzEf = fin0(ovz);
  const zredeno = !!(redeni && znamPrichod);
  if (zredeno) {
    const roStart = rokNar + 19;
    const vylouceno = fin0(vyloucenoLet);
    const roLet = Math.max(1, rokD - roStart);
    const sVz = Math.max(0, Math.min(roLet, rokD - Math.max(prichod, roStart)) - vylouceno);
    ovzEf = (ovzEf * sVz) / Math.max(1, roLet - vylouceno);
  }
  const p = parametryProRokPriznani(rokD);
  const vz = vypoctovyZaklad(ovzEf, p.zapocetRH1);
  const p3 = p.koefRok * roky * vz;
  /* § 42 odst. 4 (15+ let doby pojištění BEZ náhradních dob) a § 42 odst. 3
   * (pod 28 let, kryto od 18). Osoba BEZ VÝDĚLKU (rodič na rodičovské, nárok
   * „ano“) ho nedostane: dobu bez náhradních dob u ní neznáme a péče o dítě je
   * náhradní doba → jen minimum § 41 odst. 3 (9 800 / 7 350 / 6 534 Kč), tak
   * jak to majitel schválil (PRO-CUNGA 4. 10. 2026, varianta B). */
  const bezVydelku = !(fin0(ovz) > 0);
  const min45 = !bezVydelku && (dobaDosud >= P.MIN45_LET || (vekEf < 28 && nekryto < 1))
    ? P.MIN45_PODIL * vypoctovyZaklad(P.PRUMERNA_MZDA, p.zapocetRH1)
    : 0;
  const stupen = (podil, minProc) => Math.ceil(ZAKLADNI_VYMERA + Math.max(p3 * podil, minProc, min45 * podil));
  return {
    ...zaklad,
    III: stupen(1, P.MIN_PROCENTNI.III),
    II: stupen(1 / 2, P.MIN_PROCENTNI.II),
    I: stupen(1 / 3, P.MIN_PROCENTNI.I),
    dopoctena: +dopoctena.toFixed(2), kraceni: +kraceni.toFixed(4), kraceno: kraceni < 1, roky,
    ovz: Math.round(ovzEf), vz: Math.round(vz), redeni: zredeno,
    /* „min45“ = 45 % průměrné mzdy (§ 42), „zakonne“ = § 41 odst. 3, null = výpočet */
    minimum: p3 >= Math.max(P.MIN_PROCENTNI.III, min45) ? null : (min45 > P.MIN_PROCENTNI.III ? "min45" : "zakonne"),
  };
}

/**
 * Štítky k invalidnímu důchodu pro obrazovky (karta pojištění, analýzy pro
 * Vietnamce). Kód → slovník `duchodInvalidni.stitek.<kód>`:
 *   minimum        zákonné minimum (45 % nebo § 41 odst. 3)
 *   bezNaroku      bez nároku: méně než 5 let pojištění z posledních 10
 *   bezNarokuPoradce bez nároku (zadal poradce)
 *   overitNarok    nárok nevíme → počítá se jako bez nároku, ověřit výpis ČSSZ
 *   chybiNarozeni  bez data narození (dopočtená doba do 65 let)
 *   osvcMinimalni  OSVČ — počítáno z minimálních záloh
 * (Štítky „rok příchodu je v budoucnosti“ a „krácená dopočtená doba“ zmizely
 * s polem „V Česku pojištěn/a od roku“ — majitel 4. 10. 2026 „Úplně
 * odstranit“. Krácení § 41 odst. 6 vzniká jen z předaného `pojistenOdRoku`,
 * který aplikace už nepředává; `detail.kraceno` zůstává jen v přímém
 * výpočtu, obrazovka ho neukazuje — dočištění 4. 10. 2026.)
 * @param {object|null} detail `spocitejDavky().invaliditaDetail`
 * @returns {string[]}
 */
export function stitkyInvalidity(detail) {
  if (!detail || detail.metodika !== "zakon") return [];
  const out = [];
  if (detail.duvod === "doba") out.push("bezNaroku");
  if (detail.duvod === "ne" && !detail.narokOverit) out.push("bezNarokuPoradce");
  if (detail.narokOverit) out.push("overitNarok");
  if (detail.narokSplnen && detail.minimum) out.push("minimum");
  if (detail.narokSplnen && detail.osvcMinimalni) out.push("osvcMinimalni");
  if (detail.chybiNarozeni) out.push("chybiNarozeni");
  return out;
}

/**
 * spocitejDavky — pro jednu osobu.
 * @param {object} p
 *   cistyPrijem, vek, osvc, rokPriznaniStarobniho — jako dřív
 *   rokNarozeni        rok narození (pro důchodový věk ročníku); bez něj se bere `vek`
 *   (pojistenVCrOdRoku se od 4. 10. 2026 IGNORUJE — majitel pole „V Česku
 *                      pojištěn/a od roku“ zrušil; počítá se vždy celý život v ČR,
 *                      jako dřív prázdné pole. Uložený rok v datech zůstává.)
 *   narokInvalidni     „ano“ / „ne“ / „nevim“ — u osoby BEZ PŘÍJMU: „nevim“ a nezadáno
 *                      = bez nároku + štítek „ověřit výpis ČSSZ“ (varianta B 4. 10.);
 *                      u osoby s příjmem „nevim“ = kontrola z doby pojištění (§ 40)
 *   (osvcMinimalni se od 5. 10. 2026 IGNORUJE — majitel volbu „OSVČ platí jen
 *                      minimální zálohy“ zrušil; OSVČ se počítá vždy z minimálních
 *                      záloh, jako dřív nezadaná volba. Uložená odpověď v datech zůstává.)
 *   rokDnes           rok přiznání invalidity (výchozí letošní)
 *   invaliditaPostaru  true = výpočet před 5. 10. 2026 (45 let, 0,75 / 0,5 %, bez
 *                      minim a nároku, hrubá × 1,39) — JEN pro uložené plány se starším razítkem
 *   hrubaPostaru       true = jen převod čistá → hrubá postaru (× 1,39, před velkou
 *                      kontrolou M2-02), zákonný výpočet invalidity zůstává — pro
 *                      pojistný engine uloženého plánu (`davkyPostaru`)
 * @returns {object} dávky: každá { current (měs.), vypadek (měs.) } + `invaliditaDetail`
 */
export function spocitejDavky(vstup = {}) {
  const {
    cistyPrijem = 0, vek = 35, osvc = false, rokPriznaniStarobniho = null,
    rokNarozeni = null, narokInvalidni = null,
    rokDnes = null, invaliditaPostaru = false, hrubaPostaru = false,
  } = vstup || {};
  // Vstupní hygiena: nefinitní (NaN/±Infinity) → 0, jinak by protekly do current/výpadku.
  // Pro platné konečné vstupy no-op (identická čísla); sazby/redukční hranice beze změny.
  const rawPrijem = +cistyPrijem;
  const prijem = Math.max(0, Number.isFinite(rawPrijem) ? rawPrijem : 0);
  /* Hrubá z čisté: po pásmech podle daní 2026 (velká kontrola M2-02); uložený
   * plán před metodikou 5. 10. 2026 (`invaliditaPostaru`) postaru × 1,39 —
   * VŠECHNY dávky tohoto volání (starobní, invalidní, nemocenská). */
  const postaruHruba = invaliditaPostaru || hrubaPostaru === true;
  const hruby = hrubaZCisteCZ(prijem, { postaru: postaruHruba });
  /* Invalidita se přiznává TEĎ → parametry aktuálního roku (RH1_KOEF / COEF_ROK).
   * Starobní důchod se přizná až v roce odchodu do penze; pokud ho volající zná,
   * použijí se parametry TOHO roku (reforma je do 2035 snižuje). Bez něj zůstává
   * chování beze změny — nic se nedomýšlí, jen se přizná v `starobniPodleRoku`. */
  const VPZ = vypoctovyZaklad(hruby);
  /* ⚠️ `+null === 0` i `+"" === 0` — bez kontroly typu by chybějící rok prošel
   * jako rok 0 a starobní důchod by se spočetl PŘEDREFORMNÍMI parametry. */
  const rokTyp = typeof rokPriznaniStarobniho;
  const rokStarob =
    (rokTyp === "number" || (rokTyp === "string" && rokPriznaniStarobniho.trim() !== ""))
      ? Math.trunc(+rokPriznaniStarobniho)
      : NaN;
  const maRokStarob = Number.isFinite(rokStarob) && rokStarob >= 1900 && rokStarob <= 2200;
  const pStarob = maRokStarob ? parametryProRokPriznani(rokStarob) : null;
  const VPZ_starob = pStarob ? vypoctovyZaklad(hruby, pStarob.zapocetRH1) : VPZ;
  /* Roky pojištění STAROBNÍHO důchodu: celá kariéra od 20 do 65 let (45).
   * Důchodový věk podle ročníku se u starobního ZÁMĚRNĚ nepoužívá (rozhodnutí
   * majitele 4. 10. 2026, bod 5 „NE“: pohnulo by to plán u každého klienta). */
  const roky = Math.max(15, DUCHODOVY_VEK - START_PRACE);
  const starobni = ZAKLADNI_VYMERA + (pStarob ? pStarob.koefRok : COEF_ROK) * roky * VPZ_starob;

  /* INVALIDITA. Postaru (uložené plány před 5. 10. 2026): dopočtená doba vždy
   * do 65 let od 20 let = 45 let, II/I 0,75 % / 0,5 %, bez minim a nároku. */
  let invIII, invII, invI, detail;
  if (invaliditaPostaru) {
    const procentni = (coef) => coef * roky * VPZ;
    invIII = ZAKLADNI_VYMERA + procentni(COEF_ROK);
    invII = ZAKLADNI_VYMERA + procentni(COEF_INVAL_II);
    invI = ZAKLADNI_VYMERA + procentni(COEF_INVAL_I);
    detail = { metodika: "puvodni", roky, narokSplnen: true };
  } else {
    /* OSVČ VŽDY na minimálních zálohách (bod 3): základ = průměr minimálních
     * vyměřovacích základů. Volbu „ne“ (= čistý × 1,39 jako zaměstnanec)
     * majitel 5. 10. 2026 zrušil — vstup `osvcMinimalni` se nečte. */
    const osvcMin = !!osvc;
    const ovz = prijem > 0 ? (osvcMin ? INVALIDITA_CZ_2026.OSVC_MIN_OVZ : hruby) : 0;
    /* OSOBA BEZ PŘÍJMU (varianta B, 4. 10. 2026): „nevím“ i nezadáno se počítá
     * jako BEZ NÁROKU a obrazovka řekne „ověřit výpis ČSSZ“. Jen výslovné
     * „ano“ dá zákonné minimum (9 800 / 7 350 / 6 534 Kč). Do 5. 10. 2026
     * tu vycházelo 4 900 Kč (jen základní výměra) — podle zákona je to buď 0,
     * nebo aspoň minimum. */
    const narokVstup = normNarok(narokInvalidni);
    let narok = narokVstup;
    let narokOverit = false;
    if (!(prijem > 0) && narok !== "ano") {
      narokOverit = narok !== "ne";
      narok = "ne";
    }
    const vekVstup = Object.prototype.hasOwnProperty.call(vstup || {}, "vek") && vstup.vek !== undefined && vstup.vek !== null && vstup.vek !== "" ? vek : null;
    const inv = invalidniDuchodCZ({
      ovz,
      vek: vekVstup == null ? null : +vekVstup,
      rokNarozeni,
      rokDnes: rokNeboNull(rokDnes) ?? new Date().getFullYear(),
      /* bez `pojistenOdRoku` = celý život v ČR (pole zrušeno 4. 10. 2026) */
      narok,
    });
    invIII = inv.III;
    invII = inv.II;
    invI = inv.I;
    detail = { ...inv, metodika: "zakon", narok: narokVstup, narokOverit, osvcMinimalni: osvcMin && prijem > 0 };
  }
  const nemocenska = nemocenskaMes(prijem, osvc, { postaru: postaruHruba });

  const radek = (current) => {
    const c = Math.round(current);
    return { current: c, vypadek: Math.max(0, Math.round(prijem - c)) };
  };
  return {
    prijem,
    vek,
    osvc,
    sablona: true,      // ŠABLONA — poradce ověří (viz DAVKY_META)
    platneOd: DAVKY_META.PLATNE_OD,
    // null = starobní počítán parametry roku PLATNE_OD, ne roku odchodu do penze
    starobniPodleRoku: maRokStarob ? rokStarob : null,
    starobni: radek(starobni),
    invalidIII: radek(invIII),
    invalidII: radek(invII),
    invalidI: radek(invI),
    /* Jak invalidní důchod vznikl (roky, krácení, minimum, nárok) — pro štítky
     * (`stitkyInvalidity`). `metodika`: „zakon“ / „puvodni“. */
    invaliditaDetail: detail,
    nemocenska: radek(nemocenska),
  };
}

/* ─────────────────────────────────────────────────────────────────────────────
 * POZŮSTALOSTNÍ DÁVKY (vdovský / vdovecký / sirotčí)
 *
 * ⚠️ ZDE JSOU DVĚ RŮZNÉ VĚCI A NESMÍ SE PLÉST:
 *
 *  A) `POZUSTALOSTNI_SABLONA` — čísla z Excelové PŘEDLOHY (pole „Očekávaný
 *     celkový sirotčí důchod"). Tohle dnes používá pojisteniEngine i planEngine
 *     jako výchozí hodnotu. Není to výpočet podle zákona, je to plochý odhad.
 *
 *  B) `pozustalostniDavkyZakon()` — VÝPOČET podle zákona o důchodovém pojištění.
 *
 * KOLIK TO DĚLÁ: u čistého příjmu 50 000 Kč a dvou dětí dá šablona 10 150 Kč/měs,
 * zákonný výpočet zhruba 44 000 Kč/měs. Dávky se od potřeby ODEČÍTAJÍ, takže
 * šablona míří do PŘEPOJIŠTĚNÍ — spočítá klientovi vyšší potřebu krytí (a tím
 * i dražší pojistku), než odpovídá tomu, co stát reálně vyplatí.
 *
 * PROČ SE PŘESTO NEPŘEPÍNÁ AUTOMATICKY: vdovský důchod náleží ze zákona jeden rok
 * a potom už jen při splnění podmínky (péče o nezaopatřené dítě, invalidita III.
 * stupně, dosažení věku). Počítat s ním plnou výší po celý horizont plánu by byla
 * chyba na druhou stranu — do PODPOJIŠTĚNÍ. Která z variant se má použít, je
 * METODICKÉ rozhodnutí majitele, ne vedlejší efekt opravy konstant.
 *
 * Zdroj: ČSSZ — Pozůstalostní důchody podrobně, https://www.cssz.gov.cz/pozustalostni-duchody-podrobne
 * a zákon č. 155/1995 Sb., § 51 a § 53. Ověřeno 2026-08-23.
 * ────────────────────────────────────────────────────────────────────────── */

/** ŠABLONA z předlohy — POUŽÍVANÝ VÝCHOZÍ STAV. Jediné místo, kde ta čísla žijí;
 *  dřív byla opsaná zvlášť v pojisteniEngine.js a zvlášť v planEngine.js. */
export const POZUSTALOSTNI_SABLONA = {
  vdovsky: 5000,        // Kč/měs
  sirotciCelkem: 5150,  // Kč/měs CELKEM za všechny děti (tak to má předloha)
  sablona: true,
  zdroj: "predloha",
  poznamka:
    "Plochý odhad z předlohy, ne výpočet podle zákona. Podle zákona je vdovský i sirotčí VYŠŠÍ (viz pozustalostniDavkyZakon) — šablona proto nadhodnocuje potřebu krytí.",
};

/* Zákonné podíly a minima (2026). Základní výměra je společná se starobním
 * důchodem (ZAKLADNI_VYMERA) a přičítá se ke KAŽDÉMU přiznanému důchodu. */
export const VDOVSKY_PODIL = 0.50;      // 50 % procentní výměry zemřelého
export const SIROTCI_PODIL = 0.40;      // 40 % procentní výměry, KAŽDÉMU dítěti zvlášť
export const VDOVSKY_MIN_PROCENTNI = 2450;  // min. procentní výměra vdovského 2026
export const SIROTCI_MIN_PROCENTNI = 1960;  // min. procentní výměra sirotčího 2026
export const VDOVSKY_MESICU_BEZ_PODMINKY = 12; // pak už jen při splnění podmínky

/**
 * pozustalostniDavkyZakon — výpočet podle zákona (§ 51, § 53 z. 155/1995 Sb.).
 * Vdovský i sirotčí = základní výměra + podíl z PROCENTNÍ výměry důchodu zemřelého.
 * Sirotčí náleží KAŽDÉMU nezaopatřenému dítěti samostatně.
 *
 * @param {object} p { cistyPrijem, vek, osvc, deti }
 * @returns {object} { vdovsky, sirotciNaDite, sirotciCelkem, celkem, deti,
 *                     vdovskyMesicuBezPodminky, procentniVymeraZemreleho, sablona:false }
 */
export function pozustalostniDavkyZakon({ cistyPrijem = 0, vek = 35, osvc = false, deti = 0 } = {}) {
  // Procentní výměra zemřelého = jeho invalidní důchod III. stupně bez základní výměry.
  const inval3 = spocitejDavky({ cistyPrijem, vek, osvc }).invalidIII.current;
  const procentni = Math.max(0, inval3 - ZAKLADNI_VYMERA);

  const detiRaw = Array.isArray(deti) ? deti.length : Number(deti);
  const pocetDeti = Number.isFinite(detiRaw) ? Math.max(0, Math.floor(detiRaw)) : 0;

  const vdovsky = Math.round(ZAKLADNI_VYMERA + Math.max(VDOVSKY_MIN_PROCENTNI, VDOVSKY_PODIL * procentni));
  const sirotciNaDite = Math.round(ZAKLADNI_VYMERA + Math.max(SIROTCI_MIN_PROCENTNI, SIROTCI_PODIL * procentni));
  const sirotciCelkem = sirotciNaDite * pocetDeti;

  return {
    vdovsky,
    sirotciNaDite,
    sirotciCelkem,
    celkem: vdovsky + sirotciCelkem,
    deti: pocetDeti,
    procentniVymeraZemreleho: Math.round(procentni),
    vdovskyMesicuBezPodminky: VDOVSKY_MESICU_BEZ_PODMINKY,
    sablona: false,
    platneOd: DAVKY_META.PLATNE_OD,
  };
}

/* Řádky pro UI/PDF (popisky + barvy + krátké vysvětlení pro klienta).
 * `sablona: true` u každého řádku — konzumující stránka MUSÍ zobrazit, že jde
 * o orientační odhad (dřív byl disclaimer jen v hlavičce souboru a záleželo na
 * tom, jestli si ho stránka vezme). */
/* `klic`/`klicHint` = cesta do slovníku. React UI má číst přes ně
 * (`t(r.klic, r.label)`); `label`/`hint` zůstávají česky jako fallback pro
 * ne-React cesty (PDF builder, tisk) a pro testy metodiky. */
export const DAVKY_RADKY = [
  { key: "starobni", klic: "davkyUi.starobni", klicHint: "davkyUi.starobniHint", label: "Starobní důchod", color: "#5b8def", hint: "odhad, kdybyste šel do penze s dnešním příjmem (bez valorizace)", sablona: true },
  { key: "invalidIII", klic: "davkyUi.invalidIII", klicHint: "davkyUi.invalidIIIHint", label: "Invalidní důchod III. stupně", color: "#c4673a", hint: "úplná invalidita — nemůžete pracovat", sablona: true },
  { key: "invalidII", klic: "davkyUi.invalidII", klicHint: "davkyUi.invalidIIHint", label: "Invalidní důchod II. stupně", color: "#cf8a3a", hint: "vážné omezení práce", sablona: true },
  { key: "invalidI", klic: "davkyUi.invalidI", klicHint: "davkyUi.invalidIHint", label: "Invalidní důchod I. stupně", color: "#9a7b00", hint: "částečné omezení práce", sablona: true },
  // 60 % je sazba DO 30. dne; od 31. dne 66 %, od 61. dne 72 %. Prvních 14 dní
  // platí náhradu mzdy zaměstnavatel — nemocenská běží až od 15. dne.
  { key: "nemocenska", klic: "davkyUi.nemocenska", klicHint: "davkyUi.nemocenskaHint", label: "Nemocenská (od 15. dne)", color: "#3f7d63", hint: "krátká nemoc / úraz — 60 % redukovaného základu", sablona: true },
];
